import React from "react";
import UniversityBanner from "../../images/university-registration-banner.png";
import "./UniversityRegistrationFormStyles.scss";
import UniversitiesRegistrationForm from "./components/UniversitiesRegistrationForm";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
const UniversitiesRegistration: React.FC = () => {
  return (
    <div
      className="flex flex-col md:flex-row w-full justify-end bg-white overflow-hidden relative py-10 responsive-banner-height"
      style={{
        backgroundImage: `url(${UniversityBanner})`,
        minHeight: "600px",
        backgroundPosition: "top center",
        backgroundRepeat: "no-repeat",
        boxShadow: "4px 4px 15px 0px #0000001A",
      }}
    >
      {" "}
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row gap-3">
          <div className="w-full">
            <Breadcrumbs
              links={[
                { name: "Home", path: "/" },
                {
                  name: "Scholarship Events",
                  path: "/events/college-mentor-scholarship",
                },
                {
                  name: "Universities",
                  path: "/college-mentor-scholarship/event/universities",
                },
              ]}
            />
          </div>
          <div className="flex justify-center lg:justify-end">
            <div className="w-full sm:w-[500px] p-6 bg-white flex flex-col rounded-xl gap-4 max-md:mt-20 max-xs:!mt-10 shadow-xl">
              <div className="flex flex-col gap-1">
                <h2 className="text-2xl font-bold text-black">
                  For Universities{" "}
                </h2>
                <p className="text-black text-sm">Help us with a few details</p>
              </div>
              <div className="flex flex-col">
                <UniversitiesRegistrationForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UniversitiesRegistration;
